import { Input } from '@zoom/react-ui'
import { useState, useRef, useEffect, useCallback } from 'react'
import './SearchForm.css'

function usePrevious(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function SearchForm({ searchTerm, handleSubmit }) {
  const [value, setValue] = useState(searchTerm)
  const prevValue = usePrevious(value)
  const shouldSearch =
    value !== undefined &&
    value.trim().length !== 0 &&
    prevValue !== value &&
    searchTerm !== value

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault()
      if (shouldSearch) {
        handleSubmit(value)
      }
    },
    [handleSubmit, value, shouldSearch]
  )

  return (
    <form className="SearchForm" onSubmit={onSubmit}>
      <Input.Search
        aria-label="Search"
        placeholder="Search Pexels"
        allowClear
        value={value === null ? '' : value}
        onChange={(e) => {
          setValue(e.target.value)
        }}
      />
    </form>
  )
}

export default SearchForm
